import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, UsersIcon, MessageSquareIcon, FileCheckIcon, PenToolIcon, ListTodoIcon } from 'lucide-react';
export function ResultsSection() {
  const results = [{
    icon: LightbulbIcon,
    text: 'Una idea específica (no generalidades)'
  }, {
    icon: UsersIcon,
    text: 'Tu audiencia ideal definida con una plantilla'
  }, {
    icon: MessageSquareIcon,
    text: 'Tu oferta en 1 frase (clara y entendible)'
  }, {
    icon: FileCheckIcon,
    text: 'Un producto digital terminado y publicable'
  }, {
    icon: PenToolIcon,
    text: 'Ideas de contenido + guiones para ofrecer sin pena'
  }, {
    icon: ListTodoIcon,
    text: 'Checklists imprimibles para avanzar sin perderte'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-800 mb-4" data-id="element-177">
            En 14 días vas a tener:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-178">
          {results.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-50 p-6 rounded-2xl border border-cream-200 hover:border-terracotta-200 hover:shadow-lg transition-all group" data-id="element-179">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-180">
                <item.icon className="w-6 h-6 text-terracotta-500" data-id="element-181" />
              </div>
              <p className="text-lg font-medium text-brown-800" data-id="element-182">{item.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}